export default "__VITE_ASSET__gr1VayNB__"